import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldText = ({
  disabled,
  formField,
  onChange,
  value = ''
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const isError = formField.required && (showAllErrors || hasBeenBlurred) && !value;
  const fieldLabel = formField.label;
  const errorKey = `empty${fieldLabel}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: fieldLabel
      }
    }));
  }, [isError, dispatch, fieldLabel, errorKey]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: fieldLabel,
    help: formField.description,
    required: formField.required,
    error: isError,
    validationMessage: isError && errorMessage,
    paddingBlockStart: "100",
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "custom-form-field-input-text",
      disabled: disabled,
      name: formField.name,
      onChange: onChange,
      use: "on-dark",
      value: value,
      onBlur: () => setHasBeenBlurred(true)
    })
  });
};
export default CustomFormFieldText;